"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compileSchema = void 0;
const tslib_1 = require("tslib");
const ajv_1 = tslib_1.__importDefault(require("ajv"));
const ajv = new ajv_1.default({
    allErrors: true,
});
const compileSchema = (schema) => {
    const jsonSchema = schema.valueOf();
    return ajv.compile(jsonSchema);
};
exports.compileSchema = compileSchema;
//# sourceMappingURL=compileSchema.js.map